module.exports = __webpack_public_path__ + "assets/img/qianming.fa016a17.png";